import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * クロス設定削除サービス
 * @export DeleteCrossSetServive
 * @class DeleteCrossSetServive
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteCrossSetServive extends PlessJsonResponderSub<any> {
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCrossSetServive
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        deleteCrossSet: {
          condition: {
            OrderCode: this.vo.orderCode,
            CrossCode: this.vo.crossCode,
            MediumType: this.vo.mediumType,
          },
        },
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4801Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof DeleteCrossSetServive
   */
  execute(vo: any, successFunc: Function): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteCrossSet', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteCrossSetServive
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof DeleteCrossSetServive
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.dialogService.openAlertGetMessage('E0540')
  }
}
